// import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js';

// CookieConsent.run({
//      categories: {
//         necessary: {
//             enabled: true,  // this category is enabled by default
//             readOnly: true  // this category cannot be disabled
//         },
//         analytics: {}
//     },

//     language: {
//         default: 'en',
//         translations: {
//             en: {
//                 consentModal: {
//                     title: 'We use cookies',
//                     description: 'Cookie modal description',
//                     acceptAllBtn: 'Accept all',
//                     acceptNecessaryBtn: 'Reject all',
//                     showPreferencesBtn: 'Manage Individual preferences'
//                 },
//                 preferencesModal: {
//                     title: 'Manage cookie preferences',
//                     acceptAllBtn: 'Accept all',
//                     acceptNecessaryBtn: 'Reject all',
//                     savePreferencesBtn: 'Accept current selection',
//                     closeIconLabel: 'Close modal',
//                     sections: [
//                         {
//                             title: 'Somebody said ... cookies?',
//                             description: 'I want one!'
//                         },
//                         {
//                             title: 'Strictly Necessary cookies',
//                             description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

//                             //this field will generate a toggle linked to the 'necessary' category
//                             linkedCategory: 'necessary'
//                         },
//                         {
//                             title: 'Performance and Analytics',
//                             description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
//                             linkedCategory: 'analytics'
//                         },
//                         {
//                             title: 'More information',
//                             description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
//                         }
//                     ]
//                 }
//             }
//         }
//     }
// });



/* Mobile menu burger toggle */
(function () {
  const navigation = document.querySelector(".gh-navigation");
  const burger = navigation.querySelector(".gh-burger");
  if (!burger) return;

  burger.addEventListener("click", function () {
    if (!navigation.classList.contains("is-open")) {
      navigation.classList.add("is-open");
      document.documentElement.style.overflowY = "hidden";
    } else {
      navigation.classList.remove("is-open");
      document.documentElement.style.overflowY = null;
    }
  });
})();

/* Add lightbox to gallery images */
(function () {
  lightbox(
    ".kg-image-card > .kg-image[width][height], .kg-gallery-image > img"
  );
})();

/* Responsive video in post content */
(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    ".gh-content object",
    ".gh-content embed",
  ];
  reframe(document.querySelectorAll(sources.join(",")));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
  dropdown();
})();

/* Infinite scroll pagination */
(function () {
  if (
    !document.body.classList.contains("home-template") &&
    !document.body.classList.contains("post-template")
  ) {
    pagination();
  }
})();

/* Responsive HTML table */
(function () {
  const tables = document.querySelectorAll(
    ".gh-content > table:not(.gist table)"
  );

  tables.forEach(function (table) {
    const wrapper = document.createElement("div");
    wrapper.className = "gh-table";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();


// navigation menu
function toggleMobileMenu() {
  const hamburgerIcon = document.getElementById("hamburger-icon");
  hamburgerIcon.classList.toggle("open");
  const mobileMenu = document.getElementById("mobile-menu");
  mobileMenu.classList.toggle("active");
  // Lock scroll when mobile menu is active
  if (mobileMenu.classList.contains("active")) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
}

const buttons = document.querySelectorAll("[data-carousel-button]");

buttons.forEach((button) => {
  button.addEventListener("click", () => {
    const offset = button.dataset.carouselButton === "next" ? 1 : -1;
    const slides = button
      .closest("[data-carousel]")
      .querySelector("[data-slides]");

    const activeSlide = slides.querySelector("[data-active]");
    let newIndex = [...slides.children].indexOf(activeSlide) + offset;
    if (newIndex < 0) newIndex = slides.children.length - 1;
    if (newIndex >= slides.children.length) newIndex = 0;

    slides.children[newIndex].dataset.active = true;
    delete activeSlide.dataset.active;
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".post-box-title");
  // const titlesposts = document.querySelectorAll(".gh-card-title");

  let maxHeight = 0;
  // let maxTitleHeight = 0;

  // Find the maximum height among the titles
  titles.forEach((title) => {
    const height = title.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });
  // titlesposts.forEach((posttitle) => {
  //   const postheight = posttitle.offsetHeight;
  //   if (postheight > maxTitleHeight) {
  //     maxTitleHeight = postheight;
  //   }
  // });

  // Set the height of all titles to the maximum height found
  titles.forEach((title) => {
    title.style.height = `${maxHeight}px`;
  });
  // titlesposts.forEach((posttitle) => {
  //   titlesposts.style.height = `${maxTitleHeight}px`;
  // });
});
const adjustHeights = () => {
  const titles = document.querySelectorAll(".slide_h2");
  let maxHeight = 0;

  // Find the maximum height among the titles
  titles.forEach((title) => {
    const height = title.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Set the height of all titles to the maximum height found
  titles.forEach((title) => {
    title.style.height = `${maxHeight}px`;
  });
};

// Call adjustHeights initially and on window resize
adjustHeights();
window.addEventListener("resize", adjustHeights);

document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".gh-card-title");

  let maxHeight = 0;

  // Find the maximum height among the titles
  titles.forEach((title) => {
    const height = title.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Set the height of all titles to the maximum height found
  titles.forEach((title) => {
    title.style.height = `${maxHeight}px`;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".swiper", {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 20, // Space between slides in px
    centeredSlides: true, // Center the active slide
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    observer: true,
    observeParents: true,
    parallax: true,
  });
});

// light mode / dark mode
document.addEventListener("DOMContentLoaded", function () {
  const themeToggle = document.getElementById("theme-toggle"); // Desktop
  const mobileThemeToggle = document.getElementById("mobile-theme-toggle");
  const logo = document.getElementById("logo");
  const foot = document.getElementById("footer_logo");
  const currentTheme = localStorage.getItem("theme") || "light";

  // Set initial theme and icons
  setTheme(currentTheme);

  themeToggle.addEventListener("click", function () {
    toggleTheme();
  });

  mobileThemeToggle.addEventListener("click", function () {
    toggleTheme();
  });

  function toggleTheme() {
    const newTheme =
      document.documentElement.getAttribute("data-theme") === "dark"
        ? "light"
        : "dark";
    setTheme(newTheme);
  }

  function setTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
    // setIcon(theme);
    updateLogo(theme); // Add this line to update the logo based on the theme
  }

  function updateLogo(theme) {
    if (theme === "dark") {
      foot.src = "../../assets/images/Birdie Football _ Full Logo (White).png";
      logo.src = "../../assets/images/Birdie Football _ Full Logo (White).png";
    } else {
      foot.src = "../../assets/images/Birdie Football _ Full Logo (Black).png";
      logo.src = "../../assets/images/Birdie Football _ Full Logo (Black).png";
    }
  }
});

// signup popup
document.addEventListener('DOMContentLoaded', function () {
    // Check if the user has already signed up
    let signedUpEmail = localStorage.getItem('signedUpEmail');
    console.log(signedUpEmail)


    // Define the base URL for the site
    let baseURL = window.location.origin;

    // Function to redirect new users after 6 seconds
    function redirectIfNotSignedUp() {
        let hasBeenRedirected = localStorage.getItem('Redirected');

        if (!signedUpEmail && !hasBeenRedirected) {
            setTimeout(function () {
                window.location.href = baseURL + '/#/portal/';
                // Set a flag to indicate the user has been redirected
                localStorage.setItem('Redirected', 'true');
            }, 6000); // 6 seconds
        }
    }

    // Observe DOM changes to detect when the portal opens
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            const portalModal = document.querySelector('.gh-portal-signup');
            if (portalModal && mutation.addedNodes.length) {
                const signupForm = portalModal.querySelector('form[data-members-form="signup"]');

                if (signupForm) {
                    // Intercept form submission
                    signupForm.addEventListener('submit', function (event) {
                        const emailInput = signupForm.querySelector('input[data-members-email]');
                        const email = emailInput ? emailInput.value : null;

                        // Save to localStorage
                        if (email) {
                            localStorage.setItem('signedUpEmail', email);
                            localStorage.setItem('birdieTEST', "testing");
                        }
                    });
                }
            }
        });
    });

    // Start observing the body for DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Redirect new users after 6 seconds if they haven't signed up
    redirectIfNotSignedUp();
});
